import { render } from "./Evento.vue?vue&type=template&id=1377639b&scoped=true"
import script from "./Evento.vue?vue&type=script&lang=js"
export * from "./Evento.vue?vue&type=script&lang=js"

import "./Evento.vue?vue&type=style&index=0&id=1377639b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1377639b"]])

export default __exports__